
import SlidebarDoctor from "@/components/SlidebarAdmin.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "admin",
  components: {
    SlidebarDoctor,
  },
};
